import { Div } from '../../base/components/native/div'
import { IRouteParams } from '../../base/lib/router'

export const Empty = () => {

    const base = Div()
    base.cssClass({
        pointerEvents: 'none',
    })

    function exit({ to }: IRouteParams) {
    }

    async function enter({ query, from, to, data }: IRouteParams) {
    }

    return Object.assign(base, { enter, exit })
}